import CommonAPI from '@fusioncharts/charts/src/chart/_internal/commonchartapi';
import datasetFactory from '../../factories/mlpie-dataset';
const MULTILEVELPIE = 'multiLevelPie';
class MultilevelPie extends CommonAPI {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'MultilevelPie';
  }

  constructor () {
    super();
    this.defaultPaletteOptions = null;
    this.registerFactory('dataset', datasetFactory, ['canvas']);
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'MultilevelPie';
  }
  /**
   * parse defualt configuration of the chart
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.is3D = false;
    config.hasLegend = false;
    config.defaultDatasetType = MULTILEVELPIE;
    config.valuefontbold = 0;
    config.skipCanvasDrawing = true;
  }
  /**
   * function to check if the chart specific data is proper is not
   * this fn is define for specific chart types
   * @return {boolean} if JSON data is valid or not
   */
  _checkInvalidSpecificData () {
    let categories = this.getFromEnv('dataSource').category;
    if (!(categories && categories[0]) || !Array.isArray(categories)) {
      return true;
    }
  }

  _spaceManager () {
    var availableHeight,
      iapi = this,
      config = iapi.config;
    //* ***** Manage space
    iapi._allocateSpace((iapi._manageActionBarSpace &&
              iapi._manageActionBarSpace(config.availableHeight * 0.225)) || {});
    availableHeight = config.canvasHeight * 0.7; // eslint-disable-line good-practices/no-single-usage-variable
    // a space manager that manages the space for the tools as well as the captions.
    iapi._manageChartMenuBar(availableHeight);
    iapi.allocateDimensionOfChartMenuBar();
  }
}
export default MultilevelPie;
